import { FormRenderProps } from 'react-final-form';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { Row } from 'UIPackage/FormModule/components/Row';
import { Button } from 'UIPackage/MainModule/components/Button';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

import { FormFields } from './FormFields';
import styles from './CreatePreventionModal.module.scss';

interface IFormModalProps extends FormRenderProps<ICreatePreventionForm> {
  knoOrganizationsSelectOptions: IDictionarySelectOption<IKnoOrganizationDictionary>[] | undefined;
  federalLawsSelectOptions: IDictionarySelectOption<IFederalLawErvk>[] | undefined;
  onClose: () => void;
  visible: boolean;
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
  userKnoOrganisations: IUserOrganisation[];
}

export const FormModal: React.FC<IFormModalProps> = ({
  knoOrganizationsSelectOptions,
  federalLawsSelectOptions,
  onClose,
  visible,
  handleSubmit,
  userProsecutorOrganisationsSelectOptions,
  userKnoOrganisations,
}) => {
  return (
    <Modal
      modalBodyClassName={styles.ModalBody}
      modalClassName={styles.Modal}
      visible={visible}
      onClose={onClose}
      isOutsideClick={false}
    >
      <header className={styles.Header}>
        <Row margin="none">
          <div className={styles.HeaderTitle}>Создание профилактического мероприятия</div>
        </Row>
      </header>
      <ModalBody size="content" border="bottom" overflow="scroll">
        <Row notSpace notWrap>
          <div className={styles.InfoBody}>
            <div className={styles.TooltipIcon}></div>
            <div>Изменение отраженных ниже полей будет заблокировано после сохранения формы</div>
          </div>
        </Row>
        <FormFields
          knoOrganizationsSelectOptions={knoOrganizationsSelectOptions}
          federalLawsSelectOptions={federalLawsSelectOptions}
          userProsecutorOrganisationsSelectOptions={userProsecutorOrganisationsSelectOptions}
          userKnoOrganisations={userKnoOrganisations}
        />
      </ModalBody>
      <ModalActions margin="medium">
        <Button text="Сохранить" id="saveButton" size="medium" onClick={handleSubmit} color="primary" />
        <Button text="Отмена" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
